// Module
var code = "<p>[# summary]</p> <h3 id=\"актив-symbol\">Актив {symbol}</h3> <p>{description}</p> <p>Выпущен: {issuer}</p> <p>Евро (знак: €; символ: EUR) является официальной валютой стран-участниц Еврозоны.</p> ";
// Exports
export default code;